import createMuiTheme from '@material-ui/core/styles/createMuiTheme';
const defaultTheme = createMuiTheme();

const colors = {
  darkBlue: {
    main: '#1b4297',
    dark: '#233e81',
    contrastText: '#fff'
  },
  white: {
    main: '#fff'
  }
};

export default createMuiTheme({
  palette: {
    type: 'light',
    primary: { ...colors.darkBlue },
    secondary: { ...colors.white },
    text: {
      primary: '#222',
      secondary: '#fff'
    },
    background: {
      default: '#222'
    }
  },
  overrides: {
    MuiPaper: {
      root: {
        [defaultTheme.breakpoints.down('xs')]: {
          width: '100%'
        },
        [defaultTheme.breakpoints.up('sm')]: {
          width: '600px'
        }
      },
      elevation1: {
        boxShadow: 'none'
      },
      rounded: {
        borderRadius: '0px'
      }
    },
    MuiFormControl: {
      root: {
        margin: '8px 0px',
        color: defaultTheme.palette.text.secondary,
        width: '304px',
        '& > label': {
          color: '#999'
        },
        [defaultTheme.breakpoints.down('xs')]: {
          width: '100%'
        }
      }
    },
    MuiButton: {
      contained: {
        padding: '12px',
        width: 'fit-content',
        minWidth: '160px',
        margin: '8px 0px',
        [defaultTheme.breakpoints.down('xs')]: {
          width: '100%'
        }
      }
    },
    MuiMenu: {
      paper: {
        width: 'auto'
      }
    }
  }
});
